import { DateTime } from "luxon";

// export const getHour = (dateTime) => {
//   return DateTime.fromISO(dateTime, { zone: 'utc'}).toFormat("HH:mm", { locale: 'ru'});
// }

// export const getDay = (epoch) => {
//   if (!epoch) return '';
//   let dateTime = epoch;
//   if (typeof epoch !== 'object') {
//     dateTime = DateTime.fromSeconds(dateTime);
//   }
//
//   return dateTime.setLocale('ru')?.toLocaleString( { month: 'short', day: 'numeric' } );
// }

export const getDateString = (epoch) => {
  if (!epoch) return "";
  let dateTime = epoch;
  if (typeof epoch !== "object") {
    dateTime = DateTime.fromSeconds(dateTime);
  }
  return dateTime
    .setLocale("ru")
    .toLocaleString({ month: "short", day: "numeric", year: "numeric" });
};

export const getWeekday = (epoch) => {
  if (!epoch) return "";
  let dateTime = epoch;
  if (typeof epoch !== "object") {
    dateTime = DateTime.fromSeconds(dateTime);
  }

  return DateTime.fromSeconds(epoch).setLocale("ru")?.weekdayLong;
};
// export const getHourMinutes = (epoch) => {
//   if (!epoch) return '';
//   let dateTime = epoch;
//   if (typeof epoch !== 'object') {
//     dateTime = DateTime.fromSeconds(dateTime);
//   }
//
//   return DateTime.fromSeconds(epoch).setLocale('ru')?.toFormat('HH:mm');
// }

export const getHour = (dateTime) => {
  return DateTime.fromISO(dateTime, { zone: "utc" }).toFormat("HH:mm");
};

export const getHourMinutes = (epoch) => {
  if (!epoch) return "";
  let dateTime = epoch;
  if (typeof epoch !== "object") {
    dateTime = DateTime.fromSeconds(dateTime);
  }

  return DateTime.fromSeconds(epoch).setLocale("ru")?.toFormat("HH:mm");
};

export const getDay = (epoch) => {
  if (!epoch) return "";
  let dateTime = epoch;
  if (typeof epoch !== "object") {
    dateTime = DateTime.fromSeconds(dateTime);
  }

  return dateTime
    .setLocale("ru")
    ?.toLocaleString({ month: "short", day: "numeric" })
    .replace(".", "");
};

export const today = () => {
  var now = new Date();
  var startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  var timestamp = startOfDay / 1000;

  return timestamp;
};

export const now = () => {
  var now = new Date();
  return now / 1000;
};

export const plusDays = (curr, days) => {
  return curr + days * 86400;
};

export const startOfDay = (dateTime) => {
  const date = new Date(dateTime * 1000);
  const startOfDay = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
  );

  return startOfDay / 1000;
};

export const endOfDay = (dateTime) => {
  return startOfDay(dateTime) + 86399;
};

export const tomorrow = () => {
  return today() + 86399;
};

export const isDaySwitch = (first, second) => {
  if (first && second) {
    return getDay(first) !== getDay(second);
  }

  return true;
}
